export interface SchoolCourseEndorsementActionRequest {
    StudentCourseId: number;
    ActionType: EndorsementActionType;

    UpdateCompletedDateTime?: boolean;
}

export enum EndorsementActionType
{
    recreateEndorsement=1,
    deleteEndorsement=2,
    deleteEndorementAndResetFinals=3
}